/* 孫吳傳・第 15 章：逍遙津（合肥，215 年）
 * 北邊是合肥城外的魏營，城南有圍城的吳營和西邊一座高冢（開場孫權登冢自守），南邊是吳軍的大營。中間一條淝水的支流（逍遙津）東西橫過，只有一座津橋；橋的南段已經拆了。 */
export const RIVER_Y = 2700, BRIDGE_X = 3000, GAP = [2998, 2840], EDGE = [2997, 2690], HEAD = [3000, 2330], SOUTH_SIDE = [3000, 3080]; // 津橋：南段（GAP）拆了；EDGE 是斷口北邊、HEAD 是北岸橋頭
export default {
  id: 'xiaoyao', name: '逍遙津', W: 7000, H: 5000, seed: 215,
  bases: [[3000, 4400], [3600, 600]], // 吳軍大營、合肥
  rivers: [{ pts: [[-100, RIVER_Y - 40], [2000, RIVER_Y + 20], [4000, RIVER_Y - 20], [7100, RIVER_Y + 30]], hw: 230, fords: [] }],
  roads: [
    { pts: [[3200, 900], [3100, 1700], [BRIDGE_X, 2300], [BRIDGE_X, 3100], [3000, 4400]], w: 170 },
    { pts: [[3200, 900], [4400, 900], [5400, 1000]], w: 120 },
  ],
  rocks: [[1500, 1400, 420, 220], [5200, 1900, 400, 200], [1400, 3900, 420, 200], [5000, 4000, 420, 200]],
  woods: 0.4,
  sight: 0.8,
  clearings: [[3100, 1500, 600], [2300, 1250, 420], [2700, 1350, 300], [BRIDGE_X, 2300, 380], [3000, 4300, 500]],
  tents: [{ x: 3600, y: 600, n: 10, r: 520, chief: true, col: '#3b5a99', flag: '張' }, { x: 3000, y: 4400, n: 8, r: 460, chief: true, col: '#b8433a', flag: '孫' }, { x: 3150, y: 1550, n: 5, r: 300, col: '#b8433a', flag: '孫' }], // 最後一組：圍合肥的吳營
  grass: [[2400, 1900, 220, 100], [3900, 2000, 240, 100]],
};
